import { alpha } from "@mui/system";

const styles = (theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",

		position: "sticky",
		top: 0,
		zIndex: 10,
		backgroundColor: alpha(theme.palette.background.paper, 0.85),
		backdropFilter: "blur(3px)",
		minHeight: 40,
	},
	row: {
		p: 1,
		display: "flex",
		alignItems: "center",
		flexDirection: "row",
		justifyContent: "space-between",
	},
	boxButtons: { display: "flex", gap: 1, flexDirection: "row" },
});

export default styles;
